
























































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { AnalyticData, CropMonitoringDetailedData } from '@/interfaces/analyticData';
import { getParcelCropStage, getParcelStatus, isAnalyticDataValid, isSurveyValid } from '@/services/analyticData';
import AnalyticsPieChart from '@/components/dashboard/charts/AnalyticsPieChart.vue';
import AnalyticsBarChart from '@/components/dashboard/charts/AnalyticsBarChart.vue';
import AnalyticsByMonthBarChart from '@/components/dashboard/charts/AnalyticsByMonthBarChart.vue';
import AnalyticsByGrowthStageBarChart from '@/components/dashboard/charts/AnalyticsByGrowthStageBarChart.vue';
import { DashboardAnalyticData } from '@/interfaces/dashboardAnalyticData';
import AnalyticsLineChartPerDate from '@/components/dashboard/charts/AnalyticsLineChartPerDate.vue';
import AnalyticsLineChartPerGrowthStage from '@/components/dashboard/charts/AnalyticsLineChartPerGrowthStage.vue';
import Constants from '@/services/constants';
import { ProductGroupName } from '@/enums/productGroupName';
import { ProductType } from '@/enums/productType';
import { LayerName } from '@/enums/layerName';
import { FromTo } from '@/interfaces/fromTo';
import { Unit } from '@/interfaces/unit';
import { Farm } from '@/interfaces/farm';
import { AnalyticType } from '@/enums/analyticType';
import { Parcel } from '@/interfaces/parcel';
import moment from 'moment';
import constants from '@/services/constants';
import GlobalLoader from '@/components/GlobalLoader.vue';

@Component({
  components: {
    AnalyticsPieChart,
    AnalyticsBarChart,
    AnalyticsByMonthBarChart,
    AnalyticsByGrowthStageBarChart,
    AnalyticsLineChartPerDate,
    AnalyticsLineChartPerGrowthStage,
    GlobalLoader
  }
})
export default class SatDashboard extends Vue {
  productGroupName = ProductGroupName;
  productType = ProductType;
  layerName = LayerName;
  analyticType = AnalyticType;

  selectedVarieties: string[] = [];
  selectedStatuses: string[] = [];
  selectedCropSeasons: string[] = [];
  selectedStages: number[] = [];
  selectedCropType = 'crop_growth';
  selectedVillage: string[] = [];

  private cachedAnalytics: { [key: string]: AnalyticData[] } = {};

  @Prop() bucket;
  @Prop() title;
  @Prop() titlePieChart;
  @Prop() titleBarChart;
  @Prop() titleByDateChart;
  @Prop() titleByStageChart;
  @Prop() yAxesMax: number;

  cropMonitoringTypes = [
    {
      label: 'Crop Growth',
      data: 'crop_growth'
    },
    {
      label: 'Crop Stress',
      data: 'crop_stress'
    },
    {
      label: 'Water Stress',
      data: 'water_stress'
    }
  ];

  get selectedOption(): string {
    return this.$store.state.analytic.selectedProductType;
  }

  get timelineFromTo(): FromTo {
    return this.$store.state.analytic.timelineFromTo;
  }

  get selectedProductType(): ProductType {
    return this.$store.state.analytic.selectedProductType;
  }

  get selectedUnit(): Unit {
    return this.$store.state.selectedUnit;
  }

  get selectedFarm(): Farm {
    return this.$store.state.selectedFarm;
  }

  get chartPerDateAnalytics(): DashboardAnalyticData[] {
    return this.dashboardFullAnalyticData;
  }

  zoomTipFormatter(value: number, onlyMonth = false): string {
    return moment.unix(value / 1000).format(onlyMonth ? 'MMM YYYY' : constants.DATE_FORMAT_LOCALIZED);
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  get statuses() {
    const list = [];
    this.$store.state.analytic.filteredFullAnalyticData.forEach((analytic: AnalyticData) => {
      if (isAnalyticDataValid(analytic)) {
        const parcel = this.$store.state.parcels[analytic.ParcelID];
        if (parcel) {
          list.push(
            getParcelStatus(
              parcel,
              this.$store.state.analytic.fromTo.to,
              this.$root.$i18n,
              this.$store.state.selectedCountry
            )
          );
        }
      }
    });
    return [...new Set(list)].sort();
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  get stages() {
    const list = [];
    this.$store.state.analytic.filteredFullAnalyticData.forEach((analytic: AnalyticData) => {
      if (isAnalyticDataValid(analytic)) {
        const parcel = this.$store.state.parcels[analytic.ParcelID];
        if (parcel) {
          list.push(getParcelCropStage(parcel, this.$store.state.analytic.fromTo.to));
        }
      }
    });
    return [...new Set(list)].sort((a, b) => (a < b ? -1 : 1));
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  get varieties() {
    const list = [];
    this.$store.state.analytic.filteredFullAnalyticData.forEach((analytic: AnalyticData) => {
      if (isAnalyticDataValid(analytic)) {
        const parcel = this.$store.state.parcels[analytic.ParcelID];
        if (parcel) {
          list.push(parcel.Variety);
        }
      }
    });
    return [...new Set(list)].sort();
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  get cropMonitoringVarieties() {
    const list = [];
    this.$store.state.analytic.cropMonitoringDetailedData.forEach((analytic: CropMonitoringDetailedData) => {
      if (isAnalyticDataValid(analytic)) {
        let parcel = (Object.values(this.$store.state.parcels) as Parcel[]).find((p) => p.Name === analytic.ParcelID);

        if (parcel) {
          list.push(parcel.Variety);
        }
      }
    });
    return [...new Set(list)].sort();
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  get cropSeasons() {
    const list = [];
    this.$store.state.analytic.filteredFullAnalyticData.forEach((analytic: AnalyticData) => {
      if (isAnalyticDataValid(analytic)) {
        const parcel = this.$store.state.parcels[analytic.ParcelID];
        if (parcel) {
          list.push(parcel.CropSeason);
        }
      }
    });
    return [...new Set(list)].sort();
  }

  private getDashboardAnalyticData(analyticData: AnalyticData[]): DashboardAnalyticData[] {
    return analyticData.map((analyticData: AnalyticData) => {
      const parcel = this.$store.state.parcels[analyticData.ParcelID];
      let area = 0;
      if (parcel && analyticData.Value) {
        area = parcel.Area * (analyticData.Value / 100);
      }

      let categoryCount = {
        range_0_25: 0,
        range_25_50: 0,
        range_50_75: 0,
        range_75_100: 0
      };

      return {
        ...analyticData,
        categoryCount: categoryCount,
        value1: area,
        value2: parcel ? parcel.Area : 0
      };
    });
  }

  private getDashboardAnalyticDataForCropMonitoring(
    analyticData: CropMonitoringDetailedData[],
    isBarChart = false
  ): any[] {
    const isVegetativeIndex = this.$store.state.analytic.selectedProductType === ProductType.VEGETATIVE_INDEX;

    return analyticData.map((data: CropMonitoringDetailedData) => {
      let parcel;
      if (this.$store.state.analytic.selectedProductType === ProductType.VEGETATIVE_INDEX) {
        parcel = (Object.values(this.$store.state.parcels) as Parcel[]).find((p) => p.Name === data.ParcelID);
      } else {
        parcel = this.$store.state.parcels[data.ParcelID];
      }

      const cropType =
        this.selectedCropType && this.selectedCropType !== ''
          ? this.selectedCropType
          : this.cropMonitoringTypes[0].data;

      const numericValue =
        typeof data.Value === 'object' && data.Value?.[cropType]?.['value'] ? data.Value?.[cropType]['value'] : 0;

      let area = 0;
      if (parcel && numericValue) {
        area = parcel.Area * (numericValue / 100);
      }

      let categoryCount = {
        range_0_25: 0,
        range_25_50: 0,
        range_50_75: 0,
        range_75_100: 0
      };

      if (numericValue <= 0.4) {
        categoryCount.range_0_25 = 1;
      } else if (numericValue > 0.4 && numericValue <= 0.6) {
        categoryCount.range_25_50 = 1;
      } else if (numericValue > 0.6 && numericValue <= 0.8) {
        categoryCount.range_50_75 = 1;
      } else if (numericValue > 0.8) {
        categoryCount.range_75_100 = 1;
      }

      if (isVegetativeIndex) {
        return {
          ...data,
          categoryCount: categoryCount,
          value1: area,
          value2: parcel ? parcel.Area : 0
        };
      } else {
        return {
          ...data,
          value1: area,
          value2: parcel ? parcel.Area : 0
        };
      }
    });
  }

  get dashboardAnalyticData(): DashboardAnalyticData[] {
    const { selectedProductType } = this.$store.state.analytic;

    if (selectedProductType === ProductType.VEGETATIVE_INDEX) {
      return this.getDashboardAnalyticDataForCropMonitoring(
        this.analyticDataFiltered as CropMonitoringDetailedData[],
        true
      );
    }

    return this.getDashboardAnalyticData(this.analyticDataFiltered as AnalyticData[]);
  }

  get dashboardFullAnalyticData(): DashboardAnalyticData[] {
    const { selectedProductType } = this.$store.state.analytic;

    if (selectedProductType === ProductType.VEGETATIVE_INDEX) {
      return this.getDashboardAnalyticDataForCropMonitoring(this.analyticDataFiltered as CropMonitoringDetailedData[]);
    }

    return this.getDashboardAnalyticData(this.analyticFullDataFiltered as AnalyticData[]);
  }

  get analyticDataFiltered(): AnalyticData[] | CropMonitoringDetailedData[] {
    if (this.$store.state.analytic.selectedProductType === ProductType.VEGETATIVE_INDEX) {
      return this.$store.state.analytic.cropMonitoringDetailedData.filter((analyticData) =>
        this.isApplicableAnalytic(analyticData)
      );
    }
    return this.$store.state.analytic.filteredAnalyticData.filter((analyticData: AnalyticData) =>
      this.isApplicableAnalytic(analyticData)
    );
  }

  get analyticFullDataFiltered(): AnalyticData[] | CropMonitoringDetailedData[] {
    if (this.$store.state.analytic.selectedProductType === ProductType.VEGETATIVE_INDEX) {
      return this.$store.state.analytic.cropMonitoringDetailedData.filter((analyticData) =>
        this.isApplicableAnalytic(analyticData)
      );
    }
    return this.$store.state.analytic.filteredFullAnalyticData.filter((analyticData: AnalyticData) =>
      this.isApplicableAnalytic(analyticData)
    );
  }

  private isApplicableAnalytic(analyticData: AnalyticData | CropMonitoringDetailedData): boolean {
    if (!isAnalyticDataValid(analyticData)) {
      return false;
    }
    let parcel;
    if (this.$store.state.analytic.selectedProductType === ProductType.VEGETATIVE_INDEX) {
      parcel = (Object.values(this.$store.state.parcels) as Parcel[]).find((p) => p.Name === analyticData.ParcelID);
    } else {
      parcel = this.$store.state.parcels[analyticData.ParcelID];
    }
    if (parcel) {
      if (this.selectedVarieties.length && !this.selectedVarieties.includes(parcel.Variety)) {
        return false;
      }
      if (this.selectedCropSeasons.length && !this.selectedCropSeasons.includes(parcel.CropSeason)) {
        return false;
      }
      if (this.selectedVillage.length) {
        const farm = this.$store.state.selectedUnitHierarchy.Farms.find((f) => f.id === parcel.FarmID);
        if (!farm || !this.selectedVillage.includes(farm.id)) {
          return false;
        }
      }
      if (
        this.selectedStatuses.length &&
        !this.selectedStatuses.includes(
          getParcelStatus(
            parcel,
            this.$store.state.analytic.fromTo.to,
            this.$root.$i18n,
            this.$store.state.selectedCountry
          )
        )
      ) {
        return false;
      }
      if (
        !this.isStageBarChartHidden &&
        this.selectedStages.length &&
        !this.selectedStages.includes(getParcelCropStage(parcel, this.$store.state.analytic.fromTo.to))
      ) {
        return false;
      }
    }
    return true;
  }

  get isStageBarChartHidden(): boolean {
    return (
      this.$store.state.selectedCountry && Constants.indiaCountryIds.includes(this.$store.state.selectedCountry.id)
    );
  }
}
